export default "__VITE_ASSET__4a402490__"